import { render } from "./elecBoardHeat.vue?vue&type=template&id=61e94fb8"
import script from "./elecBoardHeat.vue?vue&type=script&lang=js"
export * from "./elecBoardHeat.vue?vue&type=script&lang=js"

import "./elecBoardHeat.vue?vue&type=style&index=0&id=61e94fb8&lang=css"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__